import React from 'react';
import {AnimatePresence, motion} from 'framer-motion';
import {Link} from 'react-router-dom';

const MenuItem = ({link}) => {
  const baseClass = "py-3 text-sub font-bold";
  const specialClass = "w-[calc(100%-3rem)] mx-auto mb-2 bg-ink text-white rounded-lg text-center hover:bg-ink-soft";
  const normalClass = "px-6 text-ink-light hover:text-ink hover:bg-white-cloud";

  const className = `block ${baseClass} ${link.special ? specialClass : normalClass}`;

  if (link.isExternal) {
    return (
      <a href={link.path} target="_blank" rel="noopener noreferrer" className={className}>
        {link.text}
      </a>
    );
  }

  if (link.onClick) {
    return <button onClick={link.onClick} className={className}>{link.text}</button>;
  }

  return <Link to={link.path} className={className}>{link.text}</Link>;
};

const MobileMenu = ({isOpen, isAuthenticated, setActiveMenu, scrolled}) => {
    const links = [
        ...(isAuthenticated
            ? [{text: "Profile", path: "/profile"}]
            : [{text: "Join the Community", onClick: () => setActiveMenu('pricing'), special: true}]),
        {text: "Playlists", path: "/playlists"},
        {text: "Submissions", path: "/submissions"},
        {text: "Discord", path: "https://discord.gg/D3ngmymWQe", isExternal: true},
        {text: "Shop", path: "/shop"}
    ];

    return (
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    initial={{opacity: 0}}
                    animate={{opacity: 1}}
                    exit={{opacity: 0}}
                    transition={{duration: 0.15}}
                    className={`fixed inset-x-0 mx-4 bg-white-pure rounded-lg border-[1.5px] border-ink z-40 ${
                      scrolled ? 'bottom-24' : 'top-16'
                    }`}
                >
                    <nav className="py-4">
                        {links.map((link, i) => (
                            <MenuItem key={link.path || i} link={link} />
                        ))}
                    </nav>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default MobileMenu;
